import { useEffect, useState } from 'react';
import type { User } from '../../../models/user';
import { emptyUser } from '../../../models/empty-user';

export const useUser = (initialUser: User) => {
  const [user, setUser] = useState<User>(initialUser);

  useEffect(() => {
    setUser(initialUser);
  }, [initialUser?.id]);

  const updateUser = (newUser: User) => {
    setUser(newUser);
  };

  const resetState = () => {
    setUser({ ...emptyUser });
  };

  return {
    user,
    updateUser,
    resetState,
  };
};
